import React from 'react';
import { motion } from 'framer-motion';

const risks = [
  {
    icon: '📍',
    title: 'Farm selection',
    description: 'Soil, water table & site evaluation',
  },
  {
    icon: '🛡️',
    title: 'Pest & disease',
    description: 'Certified material, expert monitoring',
  },
  {
    icon: '💧',
    title: 'Climate & water',
    description: 'Drip irrigation, resilient varieties',
  },
  {
    icon: '🌱',
    title: 'Soil health',
    description: 'Organic amendments, fertigation',
  },
  {
    icon: '👥',
    title: 'Skilled workforce',
    description: 'Trained, dedicated farm teams',
  },
  {
    icon: '🏪',
    title: 'Market access',
    description: 'Diversified buyers & value-add lines',
  },
];

const RiskManaged = () => {
  return (
    <section className="pt-12 md:pt-16 pb-6 md:pb-8 bg-gradient-to-b from-white via-green-50/30 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-8"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h3 className="text-sm font-bold uppercase tracking-[0.2em] mb-3 text-transparent bg-clip-text bg-gradient-to-r from-green-700 to-emerald-500">
            Risk, Actively Managed
          </h3>
          <p className="text-base text-gray-600 font-serif max-w-xl mx-auto">
            Three years of hands-on agricultural experience, growing responsibly with proven risk management
          </p>
        </motion.div>

        {/* 3x2 Tile Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {risks.map((item, index) => (
            <motion.div
              key={index}
              className="group relative bg-gradient-to-br from-white to-green-50/40 border border-green-100/70 rounded-2xl p-6 md:p-8 text-center overflow-hidden shadow-[0_6px_20px_-12px_rgba(2,58,16,0.25)] hover:shadow-[0_20px_45px_-15px_rgba(2,58,16,0.4)] hover:-translate-y-1.5 transition-all duration-300 cursor-default"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              viewport={{ once: true }}
            >
              {/* Default view — icon + title */}
              <div className="transition-all duration-300 group-hover:opacity-0 group-hover:-translate-y-3">
                <div className="mx-auto mb-4 w-16 h-16 rounded-2xl bg-gradient-to-br from-green-50 to-emerald-100 ring-1 ring-green-100 shadow-sm flex items-center justify-center text-3xl md:text-4xl">{item.icon}</div>
                <h4 className="text-sm md:text-base font-bold text-[rgb(2,58,16)] tracking-wide">{item.title}</h4>
              </div>

              {/* Hover view — icon + title + description */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-5 opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 bg-gradient-to-br from-[rgb(2,58,16)] to-green-700 rounded-2xl">
                <div className="mb-3 w-12 h-12 rounded-xl bg-white/15 flex items-center justify-center text-2xl">{item.icon}</div>
                <h4 className="text-sm font-bold text-white mb-2">{item.title}</h4>
                <p className="text-xs text-white/80 font-serif leading-relaxed">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RiskManaged;
